import React from 'react';
import videojs from 'video.js'
import 'video.js/dist/video-js.css';
import './info.scss'
import flvjs from 'flv.js';
interface State {
  playing: boolean,
}
interface Props {
  className: string,
  style: Object,
  // https://www.gsteps.live/app/s1.m3u8
  m3u8Url: string,
  flvUrl: string,
  poster: string,
  autoplay: boolean,
  controls: boolean,
  videoMirror: number,
}
export default class VideoPlayer extends React.Component<Props, State> {
  player:any = null;
  videoNode:any = null;
  isFlvMode = false;  //可以播放 flv 格式
  config = {
   
    // enableStashBuffer: false,
    // stashInitialSize: 128,
    // isLive: true,
    // autoCleanupMaxBackwardDuration: 60,
    // autoCleanupMinBackwardDuration: 30,
    // statisticsInfoReportInterval: 2000,

    //  // enableWorker: true,
    //  enableWorker: false,
    //  autoCleanupSourceBuffer: true,



     // 直播流基础配置
    isLive: true, //
    hasAudio: true,
    hasVideo: true,
    
    // 缓冲区配置 - 对直播流至关重要
    enableStashBuffer: false,          // 直播流建议禁用以减少延迟
    stashInitialSize: 128,            // 当enableStashBuffer为false时无效
    
    // 自动清理配置 - 避免内存泄漏
    autoCleanupSourceBuffer: true,     // 启用自动清理
    autoCleanupMaxBackwardDuration: 30, // 减少到30秒（原来60秒）
    autoCleanupMinBackwardDuration: 10, // 减少到10秒（原来30秒）
    
    // 错误处理和恢复
    enableWorker: false,               // 保持禁用避免兼容性问题
    lazyLoad: true,                   // 延迟加载
    deferLoadAfterSourceOpen: false,   // 立即加载
    
    // 直播优化配置
    liveBufferLatencyChasing: true,    // 启用延迟追赶
    liveBufferLatencyMaxLatency: 3,    // 最大延迟3秒
    liveBufferLatencyMinRemain: 0.5,   // 最小保留0.5秒
    
    // 统计和监控
    statisticsInfoReportInterval: 1000, // 减少到1秒（原来2秒）
    
    // 网络配置
    fixAudioTimestampGap: true,        // 修复音频时间戳间隙
    accurateSeek: false,               // 直播流不需要精确seek
    
    // 错误恢复配置
    reuseRedirectedURL: true,         // 重用重定向URL
    headers: {
      'User-Agent': 'flvjs'
    }
  };
  constructor(p:any) {
    super(p);
    this.state = {
      playing: false,
    }
  }

  componentDidMount() {
    // instantiate Video.js
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      if(this.player.destroy) {
        this.player.destroy()
      }
      if(this.player.dispose) {
        this.player.dispose()
      }
    }
  }

  initVideo = ($video:any) => {
    if ($video) {
      let {poster, autoplay, controls} = this.props;
      this.videoNode = $video;
      if ( flvjs.isSupported() && this.props.flvUrl ) {
        this.isFlvMode = true;
        let url = this.props.flvUrl.replace(/\.m3u8/gi, '.flv');
        let option = {
          url: url,
          type:'flv',
          // controls: true,
          // autoplay: autoplay,
          poster: poster
        };

        let flvPlayer = flvjs.createPlayer({...option }, this.config);
        flvPlayer.attachMediaElement($video);
        flvPlayer.load();
        this.player = flvPlayer;
        try {
          this.play();
        }catch (e) {
        }
      } else {
        let url = this.props.m3u8Url.replace(/\.flv/gi, '.m3u8');
        let option = {
          // poster: poster,
          // autoplay: autoplay,
          // // controls: false,
          // // controls: true,
          // textTrackDisplay : false,
          // errorDisplay : false,
          // sources: [{
          //   src: url,
          //   // type: ''
          // }]


          // 基础配置
          poster: poster,
          autoplay: autoplay,
          controls: false,  // 默认显示控制栏
          fluid: true,
          responsive: true,
          // preload: 'none',
          
          // 直播优化
          liveui: true,
          liveTracker: {
            trackingThreshold: 20,
            liveTolerance: 15
          },
          
          // HLS配置
          html5: {
            vhs: {
              enableLowInitialPlaylist: true,
              smoothQualityChange: true,
              overrideNative: true,
              withCredentials: false
            }
          },
          
          // 错误处理
          errorDisplay: false,
          notSupportedMessage: '您的浏览器不支持此视频格式',
          
          // 视频源
          sources: [{
            src: url,
            type: 'application/x-mpegURL'
          }],
          
          // UI配置
          textTrackDisplay: false,
          inactivityTimeout: 0,
          playbackRates: []  // 直播不需要倍速
        };
        this.player = videojs($video, option, ()=> {
          // console.log('onPlayerReady', this)
          // if(this.player && this.player.play) this.player.play();
          // if(this.player && this.player.load) this.player.load();
        });
      }

      if(this.videoNode) {
        // console.log(this.videoNode);
        this.videoNode.addEventListener('playing', () => {
          this.setState({
            playing: true,
          });
        });
      }

    }
  };

  play = ()=>{
    if(this.player && this.player.play){
      this.player.play();
      // this.setState({
      //   playing: true,
      // })
    }

  };

  fullScreen = () =>{
    if(this.videoNode){
      if (this.videoNode.requestFullscreen) {
        this.videoNode.requestFullscreen();
      } else if (this.videoNode.webkitRequestFullScreen) {
        this.videoNode.webkitRequestFullScreen();
      } else if (this.videoNode.mozRequestFullScreen) {
        this.videoNode.mozRequestFullScreen();
      } else if (this.videoNode.msRequestFullscreen) {
        this.videoNode.msRequestFullscreen();
      }
    }
  }

  render() {
    const { className, style, videoMirror } = this.props;
    const { playing } = this.state;
    let p = (<></>);
    if(!playing) {
      p = <div className="play"></div>
    }
    let videoMirrorClass = '';
    if(videoMirror && videoMirror === 2) {
      videoMirrorClass = 'video-mirror'
    }
    return (
      <div onClick={this.play} className="my-player">
        <div data-vjs-player>
          <video ref={this.initVideo} className={`video-js ${className} ${videoMirrorClass}`} webkit-playsinline="true" playsInline style={Object.assign({
            width: '100%',
            height: 'auto',
          }, style)} />
          {p}
          {/*<div className="full" onClick={this.fullScreen}>全屏</div>*/}
        </div>
      </div>
    )
  }
}
